import { LegalBanner } from '@/components/legal'
import { useLegalAcceptance } from '@/hooks/use-legal-acceptance-context'

/**
 * Componente que renderiza o banner de aceite de termos.
 * Deve ser colocado no local desejado do layout.
 */
export function LegalBannerSlot() {
  const { showBanner, documents, daysRemaining, openAcceptanceModal } = useLegalAcceptance()

  if (!showBanner) {
    return null
  }

  return (
    <LegalBanner
      documents={documents}
      daysRemaining={daysRemaining}
      onReviewClick={openAcceptanceModal}
    />
  )
}
